module.exports = __webpack_public_path__ + "static/media/party.196353a9.jpg";